import { Component, OnInit, NgZone, ViewChild, ElementRef } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { SaveService } from '@services/save.service';
import { FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { ViewService } from '@services/view.service';
import { CategoryService } from '@services/category.service';
import { SearchService } from '@services/search.service';
import { CATEGORYEDIT } from '@category/sra_category_edit';
import { CategoryRelatedService } from '@services/category-related.service';
import { Helper } from '@category/helper';
import { MapsAPILoader } from "@agm/core";
import { uuid } from 'uuidv4';
import * as _ from 'lodash';
import { CommonPipe } from '@pipes/common.pipe';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
@Component({
  selector: 'app-eproduct',
  templateUrl: './eproduct.component.html',
  styleUrls: ['./eproduct.component.sass']
})
export class EproductComponent implements OnInit {

  inventoryPolicy_list: any = []
  params: any = [];
  response: any = [];
  product_include: string = "";
  error: any = { upc: '', isbn: '', ean: '', name: '', currency: '', delivery: '', category: '', model: '', brand: '', discountValue: '', quantityToNotify: '', quantity: '', warranty: '', sku: '', basePrice: '' };
  btn_process = false;
  trackInventory_content = false;
  status_list: any = [];
  weightUnit_list: any = [];
  discountType_list: any = [];
  ageGroup_list: any = [];
  standards_list: any = []
  gender_list: any = [];
  sizeUnit_list: any = [];
  selected_category = "";
  condition_list: any = [];
  application = "product";
  component = "e";
  color = "";
  delivery_list: any = []
  deliveryend_list: any = [];
  deliverystart_list: any = [];
  availability_list: any = []
  related_data: any = [];
  brand_list: any = [];
  user_refresh: any = [];
  appEditForm: FormGroup;
  pathToMedia: any = {};
  image_paths: any = [];
  pid = "";
  relatedProductIds: any = [];
  public config: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true,
    maxFiles: 1
  };
  public config1: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true
  };
  constructor(private _relatedService: CategoryRelatedService, private _cpipe: CommonPipe, private _searchService: SearchService, private _categoryService: CategoryService, private fb: FormBuilder, private _saveeService: SaveService, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router, private _viewService: ViewService) {
    let THIS = this;

    this.appEditForm = this.fb.group({
      status: [],
      name: [],
      description: [],
      availability: [],
      delivered: [],
      deliveryEnd: [],
      deliveryStart: [],
      inventoryPolicy: [],
      url: [],
      delivery: [],
      discountType: [],
      weightUnit: [],
      productLength: [],
      brand: [],
      quantity: [],
      includes: new FormArray([]),
      customProperties: new FormArray([]),
      quantityToNotify: [],
      manufacturerPartNumber: [],
      sizeUnit: [],
      gender: [],
      ageGroup: [],
      ean: [],
      upc: [],
      height: [],
      width: [],
      model: [],
      additionalShippingCharges: [],
      color: [],
      size: [],
      weight: [],
      sku: [],
      currency: [],
      basePrice: [],
      discountValue: [],
      isbn: [],
      chargeTaxes: [],
      trackInventorys: [],
      warranty: [],
      notes: [],
      condition: []
    });

    this.appEditForm.get('currency').disable();
    this.route.queryParams.subscribe(params => {

      this.params = params;
      this.pid = this.params['id'];

      let p = {
        'component': this.component,
        'application': this.application,
        'id': this.pid
      };
      this._viewService.application(p).subscribe(
        data => {

          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.response = this._global.getVal(data, 'response', '');
            this.pathToMedia = this._global.getVal(this.response, 'pathToMedia', {});
            this.image_paths.push(this.pathToMedia);
            if (this._global.getVal(this.response, 'upc', '') == 0) {
              this.response['upc'] = '';
            }
            if (this._global.getVal(this.response, 'ean', '') == 0) {
              this.response['ean'] = '';
            }
            if (this._global.getVal(this.response, 'isbn', '') == 0) {
              this.response['isbn'] = '';
            }
            Object.entries(this.response['customProperties']).forEach(([key, value]) => {
              const cp = this.fb.group({
                name: [value['name']],
                value: [value['values']]
              });
              (this.appEditForm.get('customProperties') as FormArray).push(cp);

            });
            Object.entries(this.response['includes']).forEach(([key, value]) => {
              const control = this.fb.control(value);
              (this.appEditForm.controls.includes as FormArray).push(control);
            });
            let f = {
              'component': this.component,
              'application': this.application
            };
            this._formdataService.common(f, 'listStatusTypes').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.status_list = this._global.getVal(data, 'response', '');
                  this.appEditForm.get('status').setValue(this.response.status);
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });


            this._formdataService.common(f, 'discountTypes').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.discountType_list = this._global.getVal(data, 'response', '');
                  this.appEditForm.get('discountType').setValue(this._global.getVal(this.response, 'discountType', ''));
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
            this._formdataService.common(f, 'numbers').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.deliverystart_list = this._global.getVal(data, 'response', '');
                  this.deliveryend_list = this._global.getVal(data, 'response', '');
                  this.appEditForm.get('delivery').setValue(this._global.getVal(this.response, 'delivery', ''));
                  this.appEditForm.get('deliveryEnd').setValue(this._global.getVal(this.response, 'deliveryEnd', ''));
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });

            this._formdataService.common(f, 'deliveryStandards').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.standards_list = this._global.getVal(data, 'response', '');
                  this.appEditForm.get('delivered').setValue(this._global.getVal(this.response, 'delivered', ''));
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });

            this._formdataService.common(f, 'delivery').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.delivery_list = this._global.getVal(data, 'response', '');
                  this.appEditForm.get('delivery').setValue(this._global.getVal(this.response, 'delivery', ''));
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });

            this._formdataService.common(f, 'availability').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.availability_list = this._global.getVal(data, 'response', '');
                  this.appEditForm.get('availability').setValue(this._global.getVal(this.response, 'availability', ''));
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
            this._formdataService.common(f, 'condition').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.condition_list = this._global.getVal(data, 'response', '');
                  this.appEditForm.get('condition').setValue(this._global.getVal(this.response, 'condition', ''));
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
            this._formdataService.common(f, 'lengthUnits').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.sizeUnit_list = this._global.getVal(data, 'response', '');
                  this.appEditForm.get('sizeUnit').setValue(this._global.getVal(this.response, 'sizeUnit', ''));
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
            this._formdataService.common(f, 'productGender').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.gender_list = this._global.getVal(data, 'response', '');
                  this.appEditForm.get('gender').setValue(this._global.getVal(this.response, 'gender', ''));
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
            this._formdataService.common(f, 'ageGroups').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.ageGroup_list = this._global.getVal(data, 'response', '');
                  this.appEditForm.get('ageGroup').setValue(this._global.getVal(this.response, 'ageGroup', ''));
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
            this._formdataService.common(f, 'weightUnits').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.weightUnit_list = this._global.getVal(data, 'response', '');
                  this.appEditForm.get('weightUnit').setValue(this._global.getVal(this.response, 'weightUnit', ''));
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });

            this._formdataService.common(f, 'inventoryPolicy').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.inventoryPolicy_list = this._global.getVal(data, 'response', '');
                  this.appEditForm.get('inventoryPolicy').setValue(this._global.getVal(this.response, 'inventoryPolicy', ''));
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });


            let p = {
              'component': this.component,
              'application': 'category',
              'categoryType': this.application
            };
            this._categoryService.application(p).subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  let result = this._global.getVal(data, 'response', '');
                  CATEGORYEDIT.init(result, '#' + this.application + '_category', true, "categoryTree", this.response.category, this.application, true);
                  CATEGORYEDIT.init(result, '#entity_category', false, "entityTree", '', this.application, true);
                  $("div#entity_category a").click(function (e) {
                    THIS.related_data = [];
                    let id = ($(this).attr("id")).split("_");
                    let p = {
                      'component': THIS.component,
                      'application': THIS.application,
                      categoryId: id[0]
                    };

                    THIS._relatedService.related(p).subscribe(
                      data => {
                        if (!_.isEmpty(THIS._global.getVal(data, 'response', ''))) {
                          let result = THIS._global.getVal(data, 'response', '');
                          THIS.related_data = result;
                        }
                      },
                      error => {
                        console.log("error", JSON.stringify(error));
                      });
                  });
                  $("div#" + this.application + "_category").click(function (e) {
                    var $target = $(e.target);
                    if ($target.attr("id") === "categoryCheck") {
                      //  let result = Helper.getCategoryChecboxValues("categoryCheck", '');
                      THIS.selected_category = Helper.categoryJsonText("categoryCheck");
                    }
                  });
                  $("div#" + this.application + "_category ul li input").each(function (e) {
                    var $target = $(this);
                    if ($target.attr("id") === "categoryCheck") {
                      THIS.selected_category = Helper.categoryJsonText("categoryCheck");
                    }
                  });
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });

            let s = {
              'component': this.component,
              'application': 'brand',
              'sortOrder': 'desc',
              'sortString': 'createdTime',
              "start": 0,
              "rows": 100
            };
            this._searchService.application(s).subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.brand_list = this._global.getVal(data, 'response.docs', '');
                  this.appEditForm.get('brand').setValue(this._global.getVal(this.response, 'brand', ''));
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    });

  }

  @ViewChild('logo') public logo: ElementRef;
  ngOnInit() {
  }
  update() {

    this.error = { upc: '', isbn: '', ean: '', name: '', currency: '', delivery: '', category: '', model: '', brand: '', discountValue: '', quantityToNotify: '', quantity: '', warranty: '', sku: '', basePrice: '' };

    let includes = {}; let customProperties = {};
    this.btn_process = true;
    let r = this.appEditForm.value;
    let p = this._global.generateParams(r, ['includes', 'customProperties']);
    p['component'] = this.component;
    p['application'] = this.application;
    p = this._global.paramsRemoveNull(p);
    p['categoryJson'] = Helper.getCategoryChecboxValues("categoryCheck", '');
    p['id'] = this.response.id;
    Object.entries(this.appEditForm.value['includes']).forEach(([key, value]) => {
      if (value) {
        includes[uuid()] = value;
      }
    });
    p['includes'] = JSON.stringify(includes);
    let custom = [];
    Object.entries(this.appEditForm.value['customProperties']).forEach(([key, value]) => {
      if (value['name']) {
        let result = {};
        result["name"] = value['name'];
        result["values"] = value['value'];
        custom.push(result);
      }
    });
    p['customProperties'] = JSON.stringify(custom);
    p['pathToMedia'] = JSON.stringify(this.pathToMedia);
    p['currency'] = this._global.getVal(this.response, 'currency', '');

    this._saveeService.appUpdate(p).subscribe(
      data => {
        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ severity: severity, message: message });
          this.router.navigate(['/search/' + this.component + '/' + this.application]);
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'error';
          for (let key in data["errors"]) {
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
          }
          this._global.showMessage({ severity: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
  trackInventory(event) {
    this.trackInventory_content = false;
    if (this.appEditForm.get("trackInventorys").value[0] == "true") {
      this.trackInventory_content = true;
    }
  }
  addItem() {

    const control = this.fb.control('');

    (this.appEditForm.controls.includes as FormArray).push(control);
  }
  addSpecification() {
    const control = this.fb.group({
      name: [],
      value: []
    });
    (this.appEditForm.get('customProperties') as FormArray).push(control);
  }
  public conUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'photo', this.pid);
  }
  public conUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public conUploadSuccess(args: any): void {
    this.logo.nativeElement.src = this._cpipe.transform(this.response, ['image', this.application, 'id', 'name1', 'm']);
  }

  public onUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'photo', '');

  }
  public onUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public onUploadSuccess(args: any): void {
    let res = JSON.parse(args[1]);
    this.pathToMedia[res['id']] = this._global.getUploadPathToMedia(res);

  }
  public cancel() {
    this.router.navigate(['/my/' + this.application]);
  }

  removeImg(id) {
    if (this.image_paths[0]) {
      this.pathToMedia = this._global.removePathToMediaImage(this.pathToMedia, id);
      this.image_paths = [];
      this.image_paths.push(this.pathToMedia);
    }
  }
  returnZero() {
    return 0
  }
  chooseRelated(obj) {
    let r = this.relatedProductIds.find(x => x.value == obj.value);
    if (!r) {
      this.relatedProductIds.push(obj);
    }

  }
  removeRelated(obj) {
    this.relatedProductIds = this.relatedProductIds.filter(item => item.value != obj.value);
  }


}
